(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (() => {
    const reviewAnchorLinks = document.querySelectorAll('.review-anchor-link[href="#reviews"]');
    
    if (!reviewAnchorLinks.length) return;

    /**
     * Checks if user prefers reduced motion
     * @returns {boolean}
     */
    const prefersReducedMotion = () => {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };

    /**
     * Smoothly scrolls to the reviews section
     * @param {Event} event - The click event
     */
    const handleReviewAnchorClick = (event) => {
      const targetId = event.currentTarget.getAttribute('href');
      if (!targetId || !targetId.startsWith('#')) return;

      const targetElement = document.querySelector(targetId);
      if (!targetElement) return;

      event.preventDefault();

      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      const offset = 0; // You can adjust this if you need offset for fixed headers

      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: behavior
      });

      // Update URL hash without triggering scroll
      if (history.pushState) {
        history.pushState(null, null, targetId);
      } else {
        window.location.hash = targetId;
      }
    };

    // Attach event listeners to all review anchor links
    reviewAnchorLinks.forEach(link => {
      link.addEventListener('click', handleReviewAnchorClick);
    });

    // Handle initial page load with hash
    if (window.location.hash === '#reviews') {
      const reviewsSection = document.querySelector('#reviews');
      if (reviewsSection) {
        // Small delay to ensure page is fully loaded
        requestAnimationFrame(() => {
          const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
          reviewsSection.scrollIntoView({ behavior, block: 'start' });
        });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
